import React from "react";
import { MenuItem, Select } from "@mui/material";
import { styled } from "@mui/system";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Custom styled select component
const CustomSelect = styled(Select)({
  background: "white",
  height:'40px',
  borderRadius: "24px",
  "& .MuiSelect-select": {
    paddingRight: "12px !important",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiSvgIcon-root": {
    color: "#C4C4C4",
  },
});

// Custom styled MenuItem for dropdown options
const StyledMenuItem = styled(MenuItem)({
  borderRadius: "8px",
  transition: "background-color 0.3s ease, color 0.3s ease",
  "&:hover": {
    backgroundColor: "#000 !important", // Black background
    color: "white !important", // White text
    "& span": {
      color: "white !important", // Ensure span text is also white
    },
  },
});

const CustomDropdown = ({ options, value, onChange, placeholder = "Choose something", ...props }) => {
  const handleChange = (event) => {
    const selectedValue = event.target.value;
    const selectedOption = options.find((option) => option.value === selectedValue);
    onChange(selectedValue, selectedOption);
  };

  return (
    <CustomSelect
      value={value || ""}
      onChange={handleChange}
      displayEmpty
      IconComponent={ExpandMoreIcon}
      renderValue={(selected) => {
        if (!selected) {
          return <span className="body-2 dark-50" style={{marginLeft:'-100px'}}>{placeholder}</span>; // Light gray placeholder
        }
        return options.find((option) => option.value === selected)?.label;
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            boxShadow: "0px 3px 5px rgba(9, 30, 66, 0.2), 0px 0px 1px rgba(9, 30, 66, 0.31)",
            borderRadius: "8px",
            backgroundColor: "#fff",
            "& .MuiMenuItem-root": {
              transition: "background-color 0.3s ease, color 0.3s ease",
              borderRadius: "8px",
            },
            "& .MuiMenuItem-root:hover": {
              backgroundColor: "#000 !important",
              color: "white !important",
            },
            "& .MuiMenuItem-root:hover span": {
              color: "white !important",
            },
          },
        },
      }}
      {...props}
    >
      {/* Placeholder option */}
      <StyledMenuItem disabled value="">
        <div className="body-2 dark-50" style={{}}>{placeholder}</div>
      </StyledMenuItem>
      
      {/* Render dropdown options */}
      {options.map((option) => (
        <StyledMenuItem key={option.value} value={option.value}>
          <span>{option.label}</span>
        </StyledMenuItem>
      ))}
    </CustomSelect>
  );
};

export default CustomDropdown;
